module.exports = __webpack_public_path__ + "img/Servicio-portada.dfb75c9d.jpg";